
const newModel = () => {
    return {
        id: null,
        ten: null,
        duongDan: null,
        icon: null,
        menuChaId: null,
        tenMenuCha: null,
        menuCode: null,
        capDo: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
        dateCreated: null,
        dateModified: null,
        isDeleted: null,
        dateDeleted: null,
        userCreated: null,
        userModified: null,
        userDeleted: null,
        
    }
}

const newFEModel = () => {
    return {
        id: null,
        ten: null,
        duongDan: null,
        icon: null,
        menuChaId: null,
        menuCode: null,
        capDo: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
    }
}

const fromJson = (item) => {
    return {
        id: item.id,
        ten: item.ten,
        duongDan: item.duongDan,
        icon: item.icon,
        menuChaId: item.menuChaId,
        menuCode: item.menuCode,
        capDo: item.capDo,
        stt: item.stt,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false
    }
}

const parseModeltoFEModel = (item) => {
    return {
        id: item.id,
        ten: item.ten,
        duongDan: item.duongDan,
        icon: item.icon,
        menuChaId: item.menuChaId,
        menuCode: item.menuCode,
        capDo: item.capDo,
        stt: item.stt,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false
    }
}

const errors = () => {
    return {
        id: null,
        ten: null,
        duongDan: null,
        icon: null,
        menuChaId: null,
        menuCode: null,
        capDo: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
    }
}

export const menuModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    errors,
}


